<template>
  <MainLayout section="accounts">
    <b-container fluid id="accounts-container" v-bind:class="$mq">
      <b-row no-gutters>
        <b-col>
          <AccountDetails v-if="have_account()" />
          <AccountDir     v-else />
        </b-col>
      </b-row>
    </b-container>
  </MainLayout>
</template>

<script>
import MainLayout     from './components/MainLayout.vue'

import AccountDetails from './components/AccountDetails.vue'
import AccountDir     from './components/AccountDir.vue'

// copy url-set params to store
function set_params(vue){
  vue.page    = vue.ipage;
  vue.id      = vue.iid;
  vue.section = vue.isection;
}

export default {
  name: 'Accounts',

  components: {
    MainLayout,
    AccountDetails,
    AccountDir
  },

  props : {
       ipage : Number,
         iid : String,
    isection : String
  },

  computed : {
    id : {
      get : function(){
        return this.$store.state.account.id;
      },

      set : function(i){
        this.$store.commit('set_account_id', i);
      }
    },

    section : {
      get : function(){
        return this.$store.state.account.section;
      },

      set : function(s){
        this.$store.commit('set_account_section', s);
      }
    },

    page : {
      get : function(){
        return this.$store.state.account.page;
      },

      set : function(p){
        this.$store.commit('set_account_page', p);
      }
    },
  },

  watch : {
   '$route' : function(){
     set_params(this);
   }
  },

  methods : {
    have_account : function(){
      return !!this.id;
    },

    have_page : function(){
      return !!this.page;
    }
  },

  created : function(){
    set_params(this);
  },
}
</script>

<style scoped>
#accounts-container{
  flex-grow: 1;
  padding: 25px;
  padding-left: 0px;
  margin: 0;
  background: #ebeff0;
}

#accounts-container.sm{
  padding: 5px;
}
</style>
